import React from 'react'

import Element from '../../Element'
import { withTheme } from 'modules/util'

import claimTheme from './theme.scss'

export function Claim({ imgUrl, text, theme }) {
  return (
    <div className={theme.claim}>
      <Element text={text} type='claim' />

      <img alt={text} className={theme.claimImg} src={imgUrl} />
    </div>
  )
}

export default withTheme(claimTheme, Claim)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Strongest/Claim/index.js